<template>
    <div class="AboutUs">
      <div class="AboutUs_body">
        <div class="aboutUs">
            <div class="about">
                <div class="aL">
                <div class="tittle">关于我们</div>
                <span>Who Are We</span>
                <div class="lo"><div></div><div class="l2"></div></div>
                <div class="text">为促进省内外科技创新资源在我省的有效流通，提高科技创新成果与我省企业和产业需求的对接效率和合作成效，河南省科技创新促进中心在河南省科技厅指导下，开发“河南省科技成果转移转化公共服务平台（www.nttzzc.com）”，建设三个核心数据库，即全产业技术需求库、高质量技术成果库和高层次人才库，充分利用大数据、人工智能等技术手段不断升级优化智能匹配、精准推荐、线上对接等服务功能，实现优质科技成果的精准推广和技术供需双方的精准对接。平台面向省内外高校和科研院所等创新供给主体、企业等创新需求主体以及专业化服务机构，开展科技成果、产业关键共性技术需求的征集、筛选、发布；与省内外知名高校、科研院所建立常态化科技创新成果共享机制，依托平台定期开展线上线下相结合的重点成果展示、推介和对接服务，为各大企业、高校、科研机构等开展技术转移工作架设桥梁，成为供需双方有效互动的催化剂和纽带。</div>
            </div>
            <div class="aR">
                <img src="../assets/images/组 25261@2x.png" alt />
            </div>            
        </div>
        <div class="blue"></div>
</div>
<div class="play">
    <div class="Tbox">
        <div >
    <span>承办科技活动</span>
    <span class="sum">75</span>
    <span>场</span>
      </div>
      <div  class="t2">
    <span>服务企业</span>
    <span class="sum">9097</span>
    <span>家</span>
      </div>
      
    </div>
    <div class="Tbox">
        <div >
    <span>层技术合同登记额</span>
    <span class="sum">948</span>
    <span>亿元</span>
      </div>
      <div  class="t2">
    <span>匹配供需对接</span>
    <span class="sum">9018</span>
    <span>项</span>
      </div>
    </div>
</div>

<div class="ptfw">
        平台服务内容
      </div>
      <div class="middle">
<div class="div1">
<div class="c1">
    <img src="../assets/images/路径 4271@2x.png" alt />
</div>
    <div >技术需求发布</div>
</div>
<div class="div2"><div class="c1">
    <img src="../assets/images/路径 4272@2x.png" alt />
</div>
    <div >技术成果发布</div></div>
<div class="div1"><div class="c1">
    <img src="../assets/images/路径 4273@2x.png" alt />
</div>
    <div >供需留言对接</div></div>
<div class="div2"><div class="c1">
    <img src="../assets/images/组 25270@2x.png" alt />
</div>
    <div >供需智能匹配</div></div>
<div class="div1"><div class="c1">
    <img src="../assets/images/路径 4276@2x.png" alt />
</div>
    <div >技术转移全过程跟踪服务</div></div>
<div class="div2"><div class="c1">
    <img src="../assets/images/组 25272@2x.png" alt />
</div>
    <div >区域性技术转移平台建设</div></div>
<div class="div1"><div class="c1">
    <img src="../assets/images/路径 4277@2x.png" alt />
</div>
    <div >区域性技术转移平台建设</div></div>
<div class="div2"><div class="c1">
    <img src="../assets/images/组 25271@2x.png" alt />
</div>
    <div >技术合同登记</div></div>
<div class="div1"><div class="c1">
    
    <img src="../assets/images/路径 4280@2x.png" alt />
</div>
    <div >各类科技活动组织</div></div>
<div class="div2"><div class="c1">
    <img src="../assets/images/路径 4281@2x.png" alt />
</div>
    <div >科技金融服务</div></div>
      </div>
      <div class="foot">
        <div class="left"><div>联系</div><div class="bl">我们</div></div>
        <div class="tel">
            <div>热线 / TEL</div>
        <div class="phone">0371-67579156</div>
    </div>
        <div class="ewm">平台公众号 <img
              
                src="../assets/images/图像 289@2x.jpg"
                alt=""
              /></div>
      </div>
      </div>
     
    </div>
  </template>
  <script>
  export default {
    data() {
      return {
        listActive: true,
        listActiveCopy: false,
        indexcopy: 0,
    
      };
    },
    methods: {
      add(index) {
        this.indexcopy = index;
        if (index == 0) {
          this.listActive = true;
          this.listActiveCopy = false;
        } else if (index == 1) {
          this.listActive = false;
          this.listActiveCopy = true;
        }
      },
    },
  };
  </script>
  <style lang="scss" scoped>
  .AboutUs {
    .AboutUs_body{
        width: 100%;
        height: 73rem;
        background-image: url("../assets/images/蒙版组 283@2x.png") ;
      
        background-size: 100% 78rem;
        margin-top: -3rem;
        background-repeat:no-repeat;
        padding-top: 5rem;
        .aboutUs{
            width: 43.5%;
            height: 40rem;
           
            margin-left: 15%;
            .about{
                display: flex;
                width: 93.7%;
                height: 28rem;
                background-color: white;
                border:2px solid #046EE6;
                margin-top: 3rem;
                border-radius: 0.25rem  0.25rem 0 0.25rem;
                text-align: left;
                padding-left: 3rem;
                padding-top: 2rem;
                .aL{
                    width: 70%;
                   
                .tittle{
                    font-size: 2rem;
                    color: #232323;
                    margin-bottom: 0.5rem;
                }
                .lo{
                    display: flex;
                    div{
                        margin-top: 1rem;
                    width: 1.5rem;
                    height: 0.5rem;
                    background-color: black;
                }
                .l2{
                    margin-top: 1rem;
                    width: 1.5rem;
                    height: 0.5rem;
                    background-color:#D8E8FF;
                }
                }
                .text{
                    font-size: 0.8rem;
                    margin-top: 1rem;
                    line-height: 2rem;
                    color: #777777;
                }
            }
            .aR{
                width: 20%;
                padding-left: 4rem;
             
              img{
                width: 50%;
              }

            }
            }
       .blue{
        width:100%;
        border-radius:0 0 0 0.25rem;
                height: 4rem;
                background-color:  #046EE6;
              
       }
        }
        .play{
           width: 27.5%; 
           height: 20rem;
           margin-left:13.6rem;
           margin-top: 8.84rem;
           background-color:  #046EE6;
           border-radius: 0 0.25rem  0.25rem 0;
           .Tbox{
            display: flex;
            text-align: center;
            div{
              width: 15rem;
              height:8rem;
              span{
                display: block;
                margin-top: 1rem;
                color: white;
                text-align: left;
                margin-left: 7rem;
              }
              .sum{
                font-size: 2rem;
              }
            }
            .t2{
                width: 15rem;
              height:8rem;
              span{
                display: block;
                margin-top: 1rem;
                color: white;
                text-align: left;
                margin-left:5rem;
              }
            }
           }
          
        }
    }
    .ptfw{
        text-align: left;
        width: 43.5%;
            height: 4rem;
            margin-left: 15%;
            margin-top: -3rem;
            font-size: 1.8rem;
            font-weight: bold;
    }
    .middle{
        width:70.6%;
            height: 10rem;
            margin-left: 15%;
            display: flex;
            text-align: center;
            .div1{
                width: 7.7%;
                height:8rem;
                  padding: 1rem;
                  background-color: #046EE6;
                  .c1{
                    width: 4rem;
                    height: 4rem;
                 margin-left: 0.7rem;
                 border: 1.5px solid white;
                 border-radius: 50%;
                 img {
                    width: 2rem;
                    height: 2rem;
                    margin-top: 1rem;
                  }
                }
                div{
                    margin-top: 0.5rem;
                    color: white;
                }
            }
            .div2{
                  width: 7.7%;
                  height:8rem;
                  padding: 1rem;
                  background-color:#3284E2;
                  .c1{
                    width: 4rem;
                    height: 4rem;
                 margin-left: 0.7rem;
                 border: 1.5px solid white;
                 border-radius: 50%;
                 img {
                    width: 2rem;
                    height: 2rem;
                    margin-top: 1rem;
                  }
                }
                div{
                    margin-top: 0.5rem;
                    color: white;
                }
            }
    }
    .foot{
        width:70.6%;
            height: 6.5rem;
            margin-left: 15%;
            margin-top: 4rem;
            display: flex;
            background-color: white;
            text-align: center;
            padding-top: 3rem;
       .left{
        font-size: 1.8rem;
        display: flex;
        font-weight: bolder;
        margin-left: 4rem;
        .bl{
            color: #046EE6;
        }
        
       }
       .tel{
        width: 25rem;
        height: 2rem;
        margin-left: 4rem;
        padding-left: 4rem;
        padding-top: 1rem;
        display: flex;
        border-left:1px solid #D2D2D2 ;
          div{
            color: #777777;
            margin-top: -0.3rem;
          }
          .phone{
            width: 10rem;
            height: 1.5rem;
            margin-top: -0.5rem;
            padding-top: 0.5rem;
            padding-left: 0.5rem;
            color: #000;
            font-weight:bold;
            text-align: left;
            margin-left: 1.4rem;
            background-color: #F3F3F3;
          }
       }
       .ewm{
        width: 15rem;
        display: flex;
        color: #777777;
        padding-top: 1rem;
        img{
            width: 5rem;
            height: 5rem;
            margin-left: 1rem;
            margin-top: -1.5rem;
        }
       }
    }
  }
  </style>
  